import React from "react";
import SVG from "../../../../../assets/images/vector/components/ProInstall/Go/go.svg";
import SVG_1200 from "../../../../../assets/images/vector/components/ProInstall/Go/go@1200.svg";
import SVG_992 from "../../../../../assets/images/vector/components/ProInstall/Go/go@992.svg";
import SVG_768 from "../../../../../assets/images/vector/components/ProInstall/Go/go@768.svg";
import SVG_mob from "../../../../../assets/images/vector/components/ProInstall/Go/go@mob.svg";
import "./index.scss";

const Go = () => (
  <picture>
    <source media="(min-width: 1366px)" srcSet={SVG} />
    <source
      media="(min-width: 1200px) and (max-width: 1365px)"
      srcSet={SVG_1200}
    />
    <source
      media="(min-width: 992px) and (max-width: 1199px)"
      srcSet={SVG_992}
    />
    <source
      media="(min-width: 768px) and (max-width: 991px)"
      srcSet={SVG_768}
    />
    <source media="(max-width: 767px)" srcSet={SVG_mob} />
    <img className="PgESM-PI-G" src={SVG} alt="" loading="lazy" />
  </picture>
);

export default Go;
